
const Utils = require('../utils.js');

exports.createEvidenceNode = function(card){
   let idPrefix = 'b';
   let fullText = card.title;
   let positivePercentage = card.votes.strongVoteCount/(card.votes.weakVoteCount + card.votes.strongVoteCount) * 100;
   let color = getEvidenceNodeColor();
   let value = 10;
   if(positivePercentage > 75){
      value = 20;
   }
   else if(positivePercentage < 25){
      value=5;
   }

   // if(card.comments.length > 0){
   //    color.border = 'rgba(255, 233, 40, 1)';
   // }

   return({
      id: idPrefix + card.id,
      label: Utils.getPreviewFromText(fullText),
      shape: 'triangle',
      color,
      text: fullText,
      value,
   })
};

exports.createReasoningNode = function(card){
   let fullText = card.title;
   return({
      id: getIdPrefixForReasoningCard(card) + card.id,
      label: Utils.getPreviewFromText(fullText),
      shape: 'triangleDown',
      color: getGreySpaceNodeColor(card.isPrivate),
      text: fullText,
   });
};

exports.createReasoningEdges = function(card){
   let idPrefix = card.isPrivate ? 'gn': 'g';
   return([
      {
         from: 'b' + card.evidenceCard1.id,
         to: idPrefix + card.id,
         id: 'd1_' + card.id
      },
      {
         from: 'b' + card.evidenceCard2.id,
         to: idPrefix + card.id,
         id: 'd2_' + card.id
      }
   ]);
};

function getIdPrefixForReasoningCard(card){
   return card.isPrivate ? 'gn': 'g';
}

const idPrefixStimulus = 's';

exports.createStimulusNode = function(card){
   return({
      id: idPrefixStimulus + card.id,
      label: Utils.getPreviewFromText(card.title),
      shape: 'square',
      color: getStimulusNodeColor(),
      text: card.title.substr(0,155),
   });
};

exports.createStimulusEdges = function(card){
   let edges = [];
   for(let evidence of card.evidenceCards){
      edges.push({
         from: 'b' + evidence.id,
         to: idPrefixStimulus + card.id,
         id: 'se_' + card.id + '_' + evidence.id,
      });
   }
   return edges;
};

function getEvidenceNodeColor(){
   let background = 'rgba(11, 189, 209, 1)';
   return({
      background: background,
      border: "rgba(240, 240, 240, 1)",
      highlight: {
         background: background,
         border: "rgba(11, 189, 209, .35)"
      },
      hover: {
         background: background,
         border: "rgba(11, 189, 209, .35)"
      }
   });
}

function getGreySpaceNodeColor(isPrivate){
   let background = isPrivate ? 'rgba(169, 173, 192, 1)' : 'rgba(43, 57, 144, 1)';

   return({
      background: background,
      border: 'rgba(240, 240, 240, 1)',
      highlight: {
         background: background,
         border: 'rgba(43, 57, 144, 1, .35)'
      },
      hover: {
         background: background,
         border: 'rgba(43, 57, 144, 1, .35)'
      }
   });
}

function getStimulusNodeColor(){
   let background = 'rgba(143, 43, 144, 1)';

   return({
      background: background,
      border: 'rgba(240, 240, 240, 1)',
      highlight: {
         background: background,
         border: 'rgba(143, 43, 144, .35)'
      },
      hover: {
         background: background,
         border: 'rgba(143, 43, 144, .35)'
      }
   });
}